const updates = [
  {
    date: '2026-07-31',
    title: '7月下旬国产片单全面上线',
    desc: '本月最后一批精选91国产免费视频已入库，涵盖剧情、喜剧、悬疑三大类型共35部高清影片，即日起可在线观看。',
    tag: '内容更新',
  },
  {
    date: '2026-07-29',
    title: '播放器升级：全站支持4K超清',
    desc: '91免费视频网站播放器全面升级，部分91传媒视频在线资源已支持4K超清画质，观影体验再上新台阶。',
    tag: '技术升级',
  },
  {
    date: '2026-07-27',
    title: '91国产小视频专区新增100部',
    desc: '91国产小视频专区迎来大规模扩容，新增100部轻松有趣的短片内容，涵盖生活、搞笑、创意等多种主题。',
    tag: '内容更新',
  },
  {
    date: '2026-07-25',
    title: '手机端观影体验优化通知',
    desc: '针对移动端用户反馈，我们对手机浏览器播放界面进行了全面优化，91国产视频在线观看更便捷流畅。',
    tag: '体验优化',
  },
  {
    date: '2026-07-22',
    title: '经典老片修复计划第三期启动',
    desc: '91年国产影片视频修复计划进入第三期，新增20部经典国产电影高清修复版，重温那些年的银幕记忆。',
    tag: '特别企划',
  },
  {
    date: '2026-07-20',
    title: 'CDN节点扩容覆盖全国',
    desc: '为保障国产高清视频免费不缓冲的承诺，我们完成了全国范围CDN节点的扩容部署，播放稳定性提升40%。',
    tag: '基础设施',
  },
  {
    date: '2026-07-18',
    title: '创作者投稿通道正式开放',
    desc: '优质国产视频创作者现在可通过投稿通道与我们合作，91免费视频网站为优秀作品提供首页推荐位。',
    tag: '平台公告',
  },
];

const tagColors: Record<string, string> = {
  '内容更新': 'bg-primary-100 text-primary-700',
  '技术升级': 'bg-accent-100 text-accent-700',
  '体验优化': 'bg-secondary-100 text-secondary-700',
  '特别企划': 'bg-accent-100 text-accent-700',
  '基础设施': 'bg-secondary-100 text-secondary-700',
  '平台公告': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            91免费视频网站的实时更新、技术升级与平台公告
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {updates.map((item, i) => (
              <div key={i} className={`relative pb-8 md:pb-10 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex items-center gap-2 mb-2">
                  <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}